"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoicePanelInfoMapper = void 0;
var VoicePanelInfoMapper = /** @class */ (function () {
    function VoicePanelInfoMapper(data) {
        this.localData = data;
    }
    VoicePanelInfoMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return VoicePanelInfoMapper;
}());
exports.VoicePanelInfoMapper = VoicePanelInfoMapper;
//# sourceMappingURL=VoicePanelInfoMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/VoicePanelInfoMapper.js
// module id = 2069
// module chunks = 8